import React, { Component } from 'react';
import { connect } from "react-redux";
import Section from '../../UI/Section';
import { LineChart, Line ,CartesianGrid,XAxis,YAxis,Tooltip,Legend} from 'recharts';

import * as userActions from '../../../_actions/userActions';
import getMyTopConnectedMembers from '../../../_selectors/userSelectors/getMyTopConnectedMembers';
import PageSubTitle from '../../UI/PageSubTitle';


class UserCreatedGraph extends Component {
  componentDidMount(){
    const {getTopConnected} = this.props;
   getTopConnected();
  }
  getWindowWidth = () => {
      try {
          if(window.innerWidth <= 770) {
            return 730;
          }
          else{
            return window.innerWidth - 100;
          }
          
      } catch (error) {
          return 730;
      }
  }
  render() {
      const { connects } = this.props;
      const width = this.getWindowWidth();
    return (
      <Section>
         <LineChart width={width} height={300} data={connects}
            margin={{ top: 5, right: 0, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis dataKey="users" />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="users" stroke="#8884d8" />
        </LineChart>
      </Section>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  connects: getMyTopConnectedMembers(state)
});
const mapDispatchToProps = dispatch  => ({
  getTopConnected: () => dispatch(userActions.getTopConnectedMembers())
});

export default connect(mapStateToProps, mapDispatchToProps)(UserCreatedGraph);


// WEBPACK FOOTER //
// ./src/_components/Home/UserCreatedGraph/index.js